import React from 'react';
import Lottie from 'react-lottie';
import animationData from '~/lotties/onboarding/loading-bicycle-black.json';

export function LoadingBicycle() {
  return (
    <Lottie
      options={{
        animationData: animationData,
        loop: true,
        autoplay: true,
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid slice',
        },
      }}
      width={150}
      height={150}
    />
  );
}
